import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _bulkDeleteLabelsRequest = {};
var _bulkDeleteLabelsResponse = {};
var _cloneLabelsRequest = {};
var _cloneLabelsResponse = {};
var _countLabelsRequest = {};
var _countLabelsResponse = {};
var _createLabelRequest = { label: '_label' };
var _createLabelResponse = { label: '_label' };
var _deleteLabelRequest = {};
var _deleteLabelResponse = {};
var _externalReferenceInfo = { lastSyncDate: 'google.protobuf.Timestamp' };
var _getLabelRequest = {};
var _getLabelResponse = { label: '_label' };
var _image = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _label = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    icon: '_image',
    externalReferenceInfo: '_externalReferenceInfo',
};
var _listLabelsRequest = {};
var _listLabelsResponse = { labels: '_label' };
var _queryLabelsRequest = {};
var _queryLabelsResponse = { labels: '_label' };
var _updateLabelRequest = {
    mask: 'google.protobuf.FieldMask',
    label: '_label',
};
var _updateLabelResponse = { label: '_label' };
function resolveComWixpressRestaurantsMenusItemLabelsV1RestaurantsMenusItemLabelsUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/restaurants-menus-item-labels',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/restaurants-menus-item-labels',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/restaurants-menus-item-labels',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/restaurants-menus-item-labels',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/restaurants-menus-item-labels',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/restaurants-menus-item-labels',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/restaurants-menus-item-labels',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/restaurants-menus-item-labels',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/restaurants-menus-item-labels',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/restaurants/item-labels',
                destPath: '',
            },
            {
                srcPath: '/restaurants/menus/v1/labels',
                destPath: '/v1/labels',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/restaurants-menus-item-labels',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * > **Note:** The Label API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Creates an item label.
 */
export function createLabel(payload) {
    var _a = serializer(_createLabelRequest, {
        _externalReferenceInfo: _externalReferenceInfo,
        _image: _image,
        _label: _label,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createLabelResponse, {
        _externalReferenceInfo: _externalReferenceInfo,
        _image: _image,
        _label: _label,
    }).fromJSON;
    function __createLabel(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item_label',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.menus_item_labels.v1.RestaurantsMenusItemLabels.CreateLabel',
            url: resolveComWixpressRestaurantsMenusItemLabelsV1RestaurantsMenusItemLabelsUrl({ protoPath: '/v1/labels', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createLabel.fromReq = fromReq;
    __createLabel.__isAmbassador = true;
    return __createLabel;
}
/**
 * > **Note:** The Labels API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Retrieves an item label by ID.
 */
export function getLabel(payload) {
    var _a = serializer(_getLabelRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getLabelResponse, {
        _externalReferenceInfo: _externalReferenceInfo,
        _image: _image,
        _label: _label,
    }).fromJSON;
    function __getLabel(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item_label',
            method: 'GET',
            methodFqn: 'com.wixpress.restaurants.menus_item_labels.v1.RestaurantsMenusItemLabels.GetLabel',
            url: resolveComWixpressRestaurantsMenusItemLabelsV1RestaurantsMenusItemLabelsUrl({ protoPath: '/v1/labels/{labelId}', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getLabel.fromReq = fromReq;
    __getLabel.__isAmbassador = true;
    return __getLabel;
}
/**
 * > **Note:** The Label API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Retrieves a list of up to 500 item labels.
 */
export function listLabels(payload) {
    var _a = serializer(_listLabelsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listLabelsResponse, {
        _externalReferenceInfo: _externalReferenceInfo,
        _image: _image,
        _label: _label,
    }).fromJSON;
    function __listLabels(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item_label',
            method: 'GET',
            methodFqn: 'com.wixpress.restaurants.menus_item_labels.v1.RestaurantsMenusItemLabels.ListLabels',
            url: resolveComWixpressRestaurantsMenusItemLabelsV1RestaurantsMenusItemLabelsUrl({ protoPath: '/v1/labels', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listLabels.fromReq = fromReq;
    __listLabels.__isAmbassador = true;
    return __listLabels;
}
/**
 * > **Note:** The Label API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Retrieves a list of item labels given the provided paging, filtering, and sorting. Up to 500 labels can be returned per request.
 *
 * For a detailed list of supported operations, see the [Supported Filters and Sorting](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/item-label/supported-filters-and-sorting) article. To learn how to query menus, see [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language).
 */
export function queryLabels(payload) {
    var _a = serializer(_queryLabelsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryLabelsResponse, {
        _externalReferenceInfo: _externalReferenceInfo,
        _image: _image,
        _label: _label,
    }).fromJSON;
    function __queryLabels(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item_label',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.menus_item_labels.v1.RestaurantsMenusItemLabels.QueryLabels',
            url: resolveComWixpressRestaurantsMenusItemLabelsV1RestaurantsMenusItemLabelsUrl({ protoPath: '/v1/labels/query', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryLabels.fromReq = fromReq;
    __queryLabels.__isAmbassador = true;
    return __queryLabels;
}
/**
 * > **Note:** The Label API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Retrieves the number of labels that match a specified filter.
 *
 * If a filter isn't passed in the request, the endpoint returns the count of all labels.
 */
export function countLabels(payload) {
    var _a = serializer(_countLabelsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_countLabelsResponse, {}).fromJSON;
    function __countLabels(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item_label',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.menus_item_labels.v1.RestaurantsMenusItemLabels.CountLabels',
            url: resolveComWixpressRestaurantsMenusItemLabelsV1RestaurantsMenusItemLabelsUrl({ protoPath: '/v1/labels/count', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __countLabels.fromReq = fromReq;
    __countLabels.__isAmbassador = true;
    return __countLabels;
}
/**
 * > **Note:** The Label API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Updates an item Label.
 *
 * Each time an item label is updated, its revision increments by 1. The existing revision must be included when updating the item labels. This ensures you're working with the latest item labels information, and it prevents unintended overwrites.
 */
export function updateLabel(payload) {
    var _a = serializer(_updateLabelRequest, {
        _externalReferenceInfo: _externalReferenceInfo,
        _image: _image,
        _label: _label,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateLabelResponse, {
        _externalReferenceInfo: _externalReferenceInfo,
        _image: _image,
        _label: _label,
    }).fromJSON;
    function __updateLabel(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item_label',
            method: 'PATCH',
            methodFqn: 'com.wixpress.restaurants.menus_item_labels.v1.RestaurantsMenusItemLabels.UpdateLabel',
            url: resolveComWixpressRestaurantsMenusItemLabelsV1RestaurantsMenusItemLabelsUrl({ protoPath: '/v1/labels/{label.id}', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateLabel.fromReq = fromReq;
    __updateLabel.__isAmbassador = true;
    return __updateLabel;
}
/**
 * > **Note:** The Label API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Deletes an item label.
 */
export function deleteLabel(payload) {
    var _a = serializer(_deleteLabelRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteLabelResponse, {}).fromJSON;
    function __deleteLabel(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item_label',
            method: 'DELETE',
            methodFqn: 'com.wixpress.restaurants.menus_item_labels.v1.RestaurantsMenusItemLabels.DeleteLabel',
            url: resolveComWixpressRestaurantsMenusItemLabelsV1RestaurantsMenusItemLabelsUrl({ protoPath: '/v1/labels/{labelId}', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteLabel.fromReq = fromReq;
    __deleteLabel.__isAmbassador = true;
    return __deleteLabel;
}
/**
 * > **Note:** The Label API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Deletes multiple item labels at once.
 */
export function bulkDeleteLabels(payload) {
    var _a = serializer(_bulkDeleteLabelsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkDeleteLabelsResponse, {}).fromJSON;
    function __bulkDeleteLabels(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item_label',
            method: 'DELETE',
            methodFqn: 'com.wixpress.restaurants.menus_item_labels.v1.RestaurantsMenusItemLabels.BulkDeleteLabels',
            url: resolveComWixpressRestaurantsMenusItemLabelsV1RestaurantsMenusItemLabelsUrl({ protoPath: '/v1/bulk/labels/delete', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkDeleteLabels.fromReq = fromReq;
    __bulkDeleteLabels.__isAmbassador = true;
    return __bulkDeleteLabels;
}
/** Clone labels from a different metasite */
export function cloneLabels(payload) {
    var _a = serializer(_cloneLabelsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_cloneLabelsResponse, {}).fromJSON;
    function __cloneLabels(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item_label',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.menus_item_labels.v1.RestaurantsMenusItemLabels.CloneLabels',
            url: resolveComWixpressRestaurantsMenusItemLabelsV1RestaurantsMenusItemLabelsUrl({ protoPath: '/v1/labels/clone', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __cloneLabels.fromReq = fromReq;
    __cloneLabels.__isAmbassador = true;
    return __cloneLabels;
}
//# sourceMappingURL=http.impl.js.map